<script>
  import MTableCellCheckBox from 'components/Data/Tables/MTable/cells/MTableCellCheckBox';
  import MTableHeaderCheckBox from 'components/Data/Tables/MTable/headers/MTableHeaderCheckBox';
  import MTableCellEmpty from 'components/Data/Tables/MTable/cells/MTableCellEmpty';

  /**
   * @exports MTableSelectableMixin
   * @mixin MTableSelectableMixin
   * @emits 'select' with all currently selected row ids in payload
   *
   * mixin for {@link MTable} contains logic about selecting rows with {@link MTableCellCheckBox}
   */

  export default {
    name: 'MTableSelectableMixin',
    props: {
      selectable: Boolean,
      selectedIds: {
        type: Array,
        default: Array
      },
      hideSelectTrigger: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      selectedIdsSet () {
        return new Set(this.selectedIds);
      },
      isAllSelected () {
        return this.dataWithoutSummary.length === this.selectedIds.length && this.isAnySelected;
      },
      isAnySelected () {
        return this.selectedIds.length > 0;
      }
    },
    watch: {
      data () {
        // if data changes, we must preserve only current rows
        const currentIdsMap = new Set(this.orderedUniqueValues);
        const currentSelectedIds = this.selectedIds.filter(itemId => currentIdsMap.has(itemId));
        this.$emit('select', currentSelectedIds);
      }
    },
    mounted () {
      if (this.selectable) {
        this.registerCellEventsListener('triggerSelect', this.onSelect);
        this.registerCellEventsListener('triggerSelectAll', this.selectAll);
      }
    },
    methods: {
      getSelectColumnParams (isNestedTable) {
        if (this.selectable && !this.hideSelectTrigger) {
          if (isNestedTable) {
            return this.fillDefaultColumnData({
              itemKey: 'expanded-nested',
              cellComponent: MTableCellEmpty
            });
          }
          return this.fillDefaultColumnData({
            itemKey: 'selected',
            headerComponent: MTableHeaderCheckBox,
            cellComponent: MTableCellCheckBox,
            align: 'center',
            static: true,
            minWidth: 36,
            resizable: false,
            on: {
              change: this.onSelect
            },
            onHeader: {
              selectAll: this.selectAll
            }
          });
        }
        return null;
      },

      onSelect ({value: selected, [this.uniqueKeyAttr]: uniqId}) {
        if (selected && !this.selectedIdsSet.has(uniqId)) {
          this.$emit('select', [...this.selectedIds, uniqId]);
        } else if (!selected && this.selectedIdsSet.has(uniqId)) {
          this.$emit('select', this.selectedIds.filter(item => item !== uniqId));
        }
      },

      selectAll (selected) {
        if (selected && !this.isAllSelected) {
          this.$emit('select', this.dataWithoutSummary.map(item => item[this.uniqueKeyAttr]));
        } else if (!selected && this.isAnySelected) {
          this.$emit('select', []);
        }
      }
    }
  };
</script>
